import { render } from "./BlogAllxImplantsDentureCare.vue?vue&type=template&id=0542f1be"
import script from "./BlogAllxImplantsDentureCare.vue?vue&type=script&lang=js"
export * from "./BlogAllxImplantsDentureCare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__